import script from "./DataStory.vue?vue&type=script&setup=true&lang=js"
export * from "./DataStory.vue?vue&type=script&setup=true&lang=js"

import "./DataStory.vue?vue&type=style&index=0&id=5e37ac45&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e37ac45"]])

export default __exports__